import React from "react";
import { MAIN_CONFIG } from "../../../config/main";

export default ({
  color = MAIN_CONFIG.COLORS.white,
  ariaLabel = "hamburger",
  ariaLabelDescription = "hamburger",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24"
      height="24"
      viewBox="0 0 50 50"
      fill="white"
      ariaLabel={ariaLabel}
      ariaLabelDescription={ariaLabelDescription}
    >
      <path d="M 0 9 L 0 11 L 50 11 L 50 9 Z M 0 24 L 0 26 L 50 26 L 50 24 Z M 0 39 L 0 41 L 50 41 L 50 39 Z"></path>
    </svg>
  );
};
